export default function CaseCTA() {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
        <h2 className="text-4xl font-bold text-gray-900 mb-6">
          想了解更多成功案例？
        </h2>
        <p className="text-lg text-gray-600 mb-8">
          我们已为500+企业提供数字化转型服务，期待与您携手共创未来
        </p>
        <div className="flex flex-wrap justify-center gap-4">
          <a
            href="/#cases"
            className="px-8 py-4 bg-teal-600 text-white rounded-full font-medium hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看更多案例
          </a>
          <a
            href="/#contact"
            className="px-8 py-4 border-2 border-teal-600 text-teal-600 rounded-full font-medium hover:bg-teal-50 transition-colors whitespace-nowrap cursor-pointer"
          >
            联系我们
          </a>
        </div>
      </div>
    </section>
  );
}
